/* site.icon.svg.js */

module.exports = {
    icon: `<svg width="12" height="28" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path class="foreground-gl" d="M10.2726 0.921875C5.03334 0.921875 0.795898 5.15931 0.795898 10.3986C0.795898 17.5061 10.2726 27.9982 10.2726 27.9982C10.2726 27.9982 19.7493 17.5061 19.7493 10.3986C19.7493 5.15931 15.5119 0.921875 10.2726 0.921875ZM10.2726 13.7831C8.40434 13.7831 6.88806 12.2668 6.88806 10.3986C6.88806 8.53031 8.40434 7.01404 10.2726 7.01404C12.1409 7.01404 13.6571 8.53031 13.6571 10.3986C13.6571 12.2668 12.1409 13.7831 10.2726 13.7831Z" fill="#5D6F80"/>
  </svg>   
    `,
};
